import userDataApi from 'data/user/api';
import { useDispatch, useSelector } from 'react-redux';
import * as redux from 'data/user/redux';
import { UserData } from 'data/user/redux';
import { setCountry } from 'lib/tracking';
import { ApiError, makeErrorFromApi } from 'lib/error';
import { useEffect } from 'react';
import { Dispatch } from 'redux';
import { useError } from 'data/error/useError';

type UseUserDataType = {
  isLoading: boolean;
  error?: ApiError;
  userData: UserData | null;
};

export const LOAD_USER_DATA_ERROR_TYPE = 'LOAD_USER_DATA_ERROR_TYPE';

export const loadUserData = async (dispatch: Dispatch) => {
  dispatch(redux.loadUserData());
  try {
    const data = await userDataApi.loadUserData();
    setCountry(data.country);
    dispatch(redux.setUserData(data));
  } catch (error: any) {
    // Since the SubLandingPage also works outside the authenticated session, it is necessary to resolve the promise as empty string.
    setCountry('');
    dispatch(redux.setUserData(null));
    throw makeErrorFromApi(LOAD_USER_DATA_ERROR_TYPE, error);
  }
};

export function useUserData(): UseUserDataType {
  const dispatch = useDispatch();
  const userDataState = useSelector(redux.selector);
  const { setError } = useError();
  useEffect(() => {
    loadUserData(dispatch).catch(setError);
  }, [dispatch, setError]);
  return {
    isLoading: userDataState.isLoading,
    userData: userDataState.data,
  };
}
